import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  
import ms from "ms";
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexYAxis,
  ApexTooltip,
  ApexMarkers,
  ApexXAxis,
  ApexPlotOptions,
  ApexGrid,
  ApexResponsive,
  ApexDataLabels,
  ApexLegend,
  ApexTitleSubtitle,
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis | ApexYAxis[];
  labels: string[];
  stroke: any; // ApexStroke;
  markers: ApexMarkers;
  grid: ApexGrid;
  responsive: ApexResponsive[];
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;  
  legend: ApexLegend;
  colors:  string[],
  title: ApexTitleSubtitle,  
};
@Component({
  selector: 'app-taketime',
  templateUrl: './taketime.component.html',
  styleUrls: ['./taketime.component.scss']
})
export class TaketimeComponent implements OnInit {
  raci;
  rel_pa;
  id_cliente;
  
  @ViewChild("chart",null) chart: ChartComponent;
  
  public chartOptions: Partial<ChartOptions>;

  constructor(
    public authService: AuthService,
    public router: Router) { 
      this.id_cliente=Number(localStorage.getItem("id_cliente"));
      this.get_org();
      this.ls_raci();
      this.id_raci=0;
      this.grafica_prev(0);
    }
  ngOnInit() {
    
  }
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
  sel_(v){
    this.id_raci=v;
    this.grafica(v);
  }
  id_raci;
  area;
  procesos;
  org_;
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
    console.log("id_cliente",localStorage.getItem("id_cliente"))
      
      this.org_=[];
      this.authService.service("/api/get_org_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
              console.log(data);
                this.org_=this.authService._org_jerarquizacion(data);
                var c=localStorage.getItem("id_role_usu")
                      
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
    selusu(c){
      console.log(c);
      console.log(this.raci);
      this.raci_=[];
      for(var i=0;i<this.raci.length;i++){
        if(this.raci[i].id_org==c){
          this.raci_.push(this.raci[i]);
        }
      }
    }
    raci_=[];
  ls_raci(){
    this.rel_pa=[];
    let postData = {
    id_cliente:Number(this.id_cliente)}
    console.log(postData);
    this.authService.service("/api/get_raci",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);             
        console.log(res);
        this.raci=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  


    }
  ttime_g="H";
  _ctime(t_,tt){
    var t=Number(t_);
    switch (this.ttime_g) {
      case "D":
        switch (tt) {
          case "D": return t; break;
          case "H": return t/24; break;
          case "M": return t/24/60; break;
          case "S": return t/24/60/60; break;    
          default:
            return 0;
            break;
        }
        break;
      case "H":
        switch (tt) {
          case "D": return t*24; break;
          case "H": return t; break;
          case "M": return t/60; break;
          case "S": return t/60/60; break;    
          default:
            return 0;
            break;
        }
        break;
        case "M":
        switch (tt) {
          case "D": return t*24*60; break;
          case "H": return t*60; break;
          case "M": return t; break;
          case "S": return t/60; break;    
          default:
            return 0;
            break;
        }
        break;
        case "S":
        switch (tt) {
          case "D": return t/24/60; break;
          case "H": return t*60*60; break;
          case "M": return t*60; break;
          case "S": return t; break;    
          default:
            return 0;
            break;
        }
        break;    
      default:
        return 0;
        break;
    }   
    return 0;
  }

async grafica(id){

  let postData = {
    id_raci:this.id_raci
  }
  this.procesos=[];
  await this.authService.service("/api/get_proceso",postData)
  .then(
    data => {
      console.log(data);
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);                      
    for(var i=0;i<res.length;i++){          
      this.procesos.push( { id:res[i].id, proceso:res[i].Titulo,descripcion:res[i].Descripcion,
        idx:res[i].idx,valor:res[i].valor}
      );
    }},
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });
  var x_axis=new Array();
  for(var i=0;i<this.procesos.length;i++){  
    if(this.procesos[i].valor!='S'){        
      x_axis.push(this.procesos[i].proceso);
    }
  }
  this.area=[];
  await this.authService.service("/api/get_area",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);                        
      for(var i=0;i<res.length;i++){       
        this.area.push({ id:res[i].id,area:res[i].area,idx:res[i].idx});        
      }           
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  

  this.rel_pa=[];      
    await  this.authService.service("/api/get_pa_2",postData)
   .then(
       data => {
         var dat = JSON.stringify(data);
         var res = JSON.parse(dat);             
         for(var i=0;i<res.length;i++){
           //console.log(res[i]);         
           this.rel_pa.push(
               {id:res[i].id,
               id_p:res[i].id_tarea,
               id_a:res[i].id_area,
               rol:res[i].rol,
               time:res[i].ttime,
               tipotime:res[i].tipo_time});
         }
         //console.log(res); 
         //this.load_rasci(); 
         //console.log(this.rel_pa);        
       },
       error => {
           var de= JSON.stringify(error);
           var di = JSON.parse(de)
           //swal.fire('¡Información incorrecta!', '', 'error');
    });  
   
  var series_=[]; 
  for(var i=0;i<this.area.length;i++){  
    var cdata=[];
    for(var j=0;j<this.procesos.length;j++){
      var tiempo=0;  
      var bnd=0;  
      for(let k=0;k<this.rel_pa.length;k++){
        if(this.procesos[j].valor!='S'){        
          if(this.rel_pa[k].id_p==this.procesos[j].id  &&  this.rel_pa[k].id_a==this.area[i].id){
            bnd=1;
            tiempo=this._ctime(this.rel_pa[k].time,this.rel_pa[k].tipotime);           
          }
        }          
      }        
      cdata.push(tiempo);
    }
    series_.push({name:this.area[i].area,data:cdata})
  }
  this.chartOptions = {
    series: series_,
    chart: {
      type: "bar",
      height: 350,
      stacked: true
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0
          }
        }
      }
    ],
    xaxis: {
      categories: 
        x_axis
      
    },
    fill: {
      opacity: 1
    },
    legend: {
      position: "right",
      offsetX: 0,
      offsetY: 50
    },
    colors:['#FFF8DC','#FFEBCD','#FFE4C4','#FFDEAD','#F5DEB3','#DEB887','#D2B48C','#BDB76B','#DAA520','#B8860B','#CD853F','#D2691E','#A0522D','#A52A2A','#B22222','#8B4513','#8B0000','#800000','#FAA460','#FF7F50','#FF6347','#FF0000','#FF4500','#FF8C00','#FFA500','#FFD700','#FFFF00']
  }
 
}
async grafica_prev(id){

 
  this.chartOptions = {
    series: [
      {
        name: "--",
        data: [44]
      }
    ],
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      stackType: "100%"
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0
          }
        }
      }
    ],
    xaxis: {
      categories: [
               ""
      ]
    },
    fill: {
      opacity: 1
    },
    legend: {
      position: "right",
      offsetX: 0,
      offsetY: 50
    }
  }
 
}


}
